import Pagination from '../valueobjects/Pagination';
import ExploreMerchant from './ExploreMerchant';
import MerchantCategory from './MerchantCategory';

export default class ExploreCategory {
  public readonly merchantCategory: MerchantCategory;
  public readonly exploerMerchants: ExploreMerchant[];
  public readonly pagination: Pagination;

  constructor(init: ExploreCategoryInitializer) {
    this.merchantCategory = new MerchantCategory(init.merchantCategory);
    this.exploerMerchants = init.exploerMerchants.map(
      exploerMerchant => new ExploreMerchant(exploerMerchant),
    );
    this.pagination = new Pagination(init.pagination);
  }
}

export interface ExploreCategoryInitializer {
  merchantCategory: MerchantCategory;
  exploerMerchants: ExploreMerchant[];
  pagination: Pagination;
}
